import React from 'react';

interface DeadlineFiltersProps {
  availableStaff: Array<{ id: string; name: string; initials: string }>;
  selectedStaffId: string | null;
  onStaffFilterChange: (staffId: string | null) => void;
  searchTerm: string;
  onSearchChange: (term: string) => void;
}

export const DeadlineFilters: React.FC<DeadlineFiltersProps> = ({
  availableStaff,
  selectedStaffId,
  onStaffFilterChange,
  searchTerm,
  onSearchChange
}) => {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: (searchTerm || selectedStaffId) 
        ? '400px 200px auto' 
        : '400px 200px',
      columnGap: '12px',
      alignItems: 'center',
      marginBottom: '20px',
      padding: '16px',
      backgroundColor: '#F9FAFB',
      borderRadius: '8px',
      border: '1px solid #E5E7EB'
    }}>
      {/* Suchfeld - Spalte 1 */}
      <input
        type="text"
        placeholder="Kunde suchen..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        style={{
          width: '100%',
          padding: '8px 12px',
          border: '1px solid #D1D5DB',
          borderRadius: '6px',
          fontSize: '14px',
          outline: 'none',
          boxSizing: 'border-box'
        }}
      />

      {/* Mitarbeiter-Filter - Spalte 2 */}
      <select
        value={selectedStaffId || ''}
        onChange={(e) => onStaffFilterChange(e.target.value || null)}
        style={{
          width: '100%',
          padding: '8px 12px',
          border: '1px solid #D1D5DB',
          borderRadius: '6px',
          fontSize: '14px',
          backgroundColor: 'white',
          cursor: 'pointer',
          outline: 'none',
          boxSizing: 'border-box'
        }}
      >
        <option value="">Alle Mitarbeiter</option>
        {availableStaff.map(staff => (
          <option key={staff.id} value={staff.id}>
            {staff.name} ({staff.initials})
          </option>
        ))}
      </select>

      {/* Reset-Button - Spalte 3 (nur wenn Filter aktiv) */}
      {(searchTerm || selectedStaffId) && (
        <button
          onClick={() => {
            onSearchChange('');
            onStaffFilterChange(null);
          }}
          style={{
            padding: '8px 16px',
            backgroundColor: '#EF4444',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '14px',
            cursor: 'pointer',
            fontWeight: '500',
            whiteSpace: 'nowrap',
            justifySelf: 'start'
          }}
        >
          Filter zurücksetzen
        </button>
      )}
    </div>
  );
};